import ProfileCard from '@/pages/customer/home/components/profileCard/ProfileCard';
import { PersonGrid } from '@/common/styles/shared.styles';
import CreateSoftieCard from '../CreateSoftieCard/CreateSoftieCard';
import MySoftiesGridSkeleton from '../MySoftiesGridSkeleton/MySoftiesGridSkeleton';

const MySoftiesGrid = ({
	persons,
	isLoading,
	createLabel,
	onCreateSoftie,
	onSelectProfile,
}) => (
	<PersonGrid id="myPersonsGrid" aria-busy={isLoading}>
		{isLoading ? (
			<MySoftiesGridSkeleton />
		) : (
			<>
				<CreateSoftieCard label={createLabel} onClick={onCreateSoftie} />
				{persons.map((profile) => (
					<ProfileCard
						key={profile._id}
						profile={profile}
						onClick={onSelectProfile}
					/>
				))}
			</>
		)}
	</PersonGrid>
);

export default MySoftiesGrid;
